import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

interface Props {
  title: string;
}

const useStyles = makeStyles({
  widget: {
    backgroundColor: '#454057',
    borderRadius: 8,
    paddingBottom: 16,
  },
  widgetTitle: {
    backgroundColor: '#564F70',
    borderRadius: '8px 8px 0px 0px',
    marginBottom: 16,
    padding: `16px`,
  },
});

const Widget: React.FC<Props> = ({ title, children }) => {
  const { widget, widgetTitle } = useStyles();
  return (
    <Box className={widget}>
      <Typography className={widgetTitle}>{title}</Typography>
      <Box p={2}>{children}</Box>
    </Box>
  );
};

export default Widget;
